import { Reveal } from "./Reveal";

export const ProductIndependence = () => (
  <section className="border-t border-brand-line bg-white">
    <div className="mx-auto max-w-6xl px-6 py-24 md:py-32 lg:px-8">
      <div className="grid grid-cols-1 gap-10 md:grid-cols-12 md:items-end">
        <div className="md:col-span-7">
          <Reveal>
            <p className="eyebrow">
              <span className="ic-triangle" aria-hidden="true" />
              Produktoberoende
            </p>
            <h2 className="mt-7 max-w-2xl font-display text-3xl font-normal leading-[1.1] tracking-[-0.01em] text-brand-ink md:text-5xl">
              Rätt lösning före rätt produkt.
            </h2>
          </Reveal>
        </div>
        <div className="md:col-span-5">
          <Reveal delay={0.08}>
            <p className="text-lg leading-relaxed text-brand-muted">
              IC Identity arbetar produktoberoende. Det gör att rekommendationer och lösningar kan
              utgå från organisationens faktiska behov, befintliga miljö och långsiktiga mål – inte
              från en viss leverantör eller plattform.
            </p>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
